import { EventChargeScope, EventDetails, EventStatus, UserEventReservationStatus } from '../../../types/event';
import moment from 'moment-timezone';
import { SecureUser } from '../../../types/user';

export class EventStatusUtils {
  static shouldDisable(alreadyReserved: boolean, event: EventDetails): boolean {
    return this.isPast(event) || alreadyReserved || this.isEventFull(event);
  }
  static isPast(event: EventDetails) {
    return moment(event.ends_at).isSameOrBefore(moment());
  }
  static isEventFull(event: EventDetails): boolean {
    return event.capacity === event.active_reservation_count || event.full;
  }
  static hasArchive(event: EventDetails): boolean {
    // TODO: アーカイブ期間のチェックできている？？？
    return event.has_archive && !!event.archive_video;
  }
  static isOnLive(event: EventDetails): boolean {
    return (
      this.hasArchive(event) && moment().isBetween(moment(event.starts_at).add(-10, 'minutes'), moment(event.ends_at))
    );
  }
  static getEventStatus(event: EventDetails): EventStatus {
    if (this.isPast(event)) {
      if (this.hasArchive(event)) {
        return 'archived';
      } else {
        return 'is_past';
      }
    }
    if (this.isOnLive(event)) {
      return 'live_casting';
    }
    if (this.isEventFull(event)) {
      return 'is_full';
    }
    return 'is_upcoming';
  }
  static getButtonText(alreadyReserved: boolean, event: EventDetails): string {
    if (this.isPast(event)) {
      return '終了しました';
    }
    if (alreadyReserved) {
      return '予約済み';
    }
    if (this.isEventFull(event)) {
      return '満員御礼';
    }
    return 'このイベントを予約する';
  }

  static isEventFreeForUser(
    event: EventDetails,
    userEventReservationStatus: UserEventReservationStatus,
    user: SecureUser
  ): boolean {
    if (event.charge_scope === EventChargeScope.ALL_USERS) return false;
    if (this.isPast(event)) {
      // 過去のイベントは現時点で会員かどうかで判別する（当時会員じゃなくても、現在会員だったら会員として扱う）
      if (!userEventReservationStatus.hasAffordableTokenForNow) return false;
    } else {
      // 未来のイベントは、開催時点で会員かどうかで判別する
      if (!userEventReservationStatus.hasAffordableTokenForEventStartAt) return false;
    }
    if (!user.membership_plan_group_keys.find((key) => event.membership_plan_group_keys.includes(key))) return false;
    return true;
  }
}
